import React, { useState } from "react";

import { useSnackbar } from "notistack";

import { ModalBody, ModalFooter } from "application/modal/index";

import { useS3FileUpload, useModelPopup } from "common/hooks";
import DragAndDrop from "common/components/dragAndDrop";
import { ALLOWED_FILE_EXTENSIONS } from "common/constants";

import { Button, BtnType, Loading } from "../../../../../primitives";
import styles from "../taskInfo.module.scss";

const UploadDocumentFile = ({ savedocument }) => {
  const popup = useModelPopup();
  const [forbiddenFiles, setForbiddenFiles] = useState([]);
  const { fileUpload } = useS3FileUpload();
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [uploadValues, setUploadValues] = useState([]);
  const [documents, setDocuments] = useState([]);

  const uploadHandler = async (e, action) => {
    if (forbiddenFiles.length) {
      setForbiddenFiles([]);
    }

    let files;

    if (action === "click") {
      if (!e || !e.target.files.length) {
        return;
      }

      files = Array.from(e.target.files);
    }

    if (action === "drop") {
      if (!e || !e.files.length) {
        return;
      }

      files = Array.from(e.files);
    }

    if (!files) {
      return;
    }

    setLoading(true);
    setUploadValues((items) => {
      const currentFiles = [...items];

      const newFiles = files.map((file) => ({
        progress: 0,
        name: file.name,
      }));
      return [...currentFiles, ...newFiles];
    });

    files.forEach(async (file) => {
      if (file.size <= 10000000) {
        const { name } = file;

        const extension = name.slice(((name.lastIndexOf(".") - 1) >>> 0) + 2);
        const isRightExtension = ALLOWED_FILE_EXTENSIONS.includes(extension);

        if (!isRightExtension) {
          const message = `Files with the extension "${extension}" are not allowed.`;
          enqueueSnackbar(message, {
            variant: "error",
            key: "extensionNotAllowed",
            persist: true,
          });

          const timeout = setTimeout(() => {
            closeSnackbar("extensionNotAllowed");
            clearTimeout(timeout);
          }, 5000);

          return;
        }

        await fileUpload(file, "documents/", setUploadValues).then((res) => {
          if (res) {
            setLoading(false);
            setDocuments(res);
            setUploadValues([]);
          }
        });
      } else {
        enqueueSnackbar(
          "We could not upload your document because your file size is too big. Please make sure the file is less than 100 MB",
          {
            variant: "error",
          }
        );
      }
    });

    e.target.value = "";
  };

  return (
    <div>
      <ModalBody>
        <div>
          {" "}
          <div className={styles.dropBoxContainer}>
            <div className={styles.dragAndDropContainer}>
              <DragAndDrop
                uploadHandler={uploadHandler}
                loading={loading}
                customText="drag and drop a document here"
              />
            </div>
            {documents?.name ? (
              <span
                className={styles.forbiddenfileName}
              >{`${documents.name} `}</span>
            ) : null}
            {forbiddenFiles?.length ? (
              <div className={styles.forbiddenfileContainer}>
                Files that weren't allowed:{" "}
                {forbiddenFiles.map((file) => (
                  <span className={styles.forbiddenfileName}>
                    {`${file.name}: `}
                    <span className={styles.errorText}> {file.error}</span>
                  </span>
                ))}
              </div>
            ) : null}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() => {
            popup.hide();
          }}
          btn={BtnType.FRAME_LESS}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            popup.hide();
            savedocument(documents?.location, documents?.name, "file");
          }}
        >
          Upload
        </Button>
      </ModalFooter>
    </div>
  );
};

export default UploadDocumentFile;
